<template lang="pug" src="./custom-treatment-tabs.pug"></template>

<script>
export default {
  props: ['props'],
  data () {
    return {
      active: 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-treatment-tabs.vue?342ff7cb